import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { IBlockedDateEmployees } from "../../@types/blockedDates";

interface EmployeeFromListRequest {
  employee_identifiers: string;
}

interface IEmployeeFromListResponse {
  employees: IBlockedDateEmployees[];
  employees_not_found: string[];
}

export const GetEmployeesFromListApiService = async (
  request: EmployeeFromListRequest
): Promise<IEmployeeFromListResponse> => {
  const url = `/employees/get_employees_list`;
  const { data } = await axios.get(`${url}`, { params: request });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useGetEmployeesFromListApiService = (
  request: EmployeeFromListRequest,
  options: any
) =>
  useQuery<
    Promise<IEmployeeFromListResponse>,
    AxiosError,
    IEmployeeFromListResponse
  >(
    ["GetEmployeesFromListApiService"],
    () => GetEmployeesFromListApiService(request),
    options
  );

export default useGetEmployeesFromListApiService;
